module.exports = __webpack_public_path__ + "img/sys (1).c8bc50c1.png";